import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Breadcrumb from 'components/Layout/Breadcrumb';
import Router from 'components/Layout/Router';
import { useUserStore } from 'stores/user';

import Header from './Header';

const Body = () => {
  const { user } = useUserStore();

  if (!user) {
    return <></>;
  }
  return (
    <>
      <Header />
      <Box display="flex" flexDirection="column" height="100%" maxWidth="100%">
        <Box mt={3}>
          <Container
            sx={{
              mb: 2,
              flexGrow: 1,
              maxWidth: 'calc(100% - 200px) !important',
              '.mainContentWithBackground': {
                flexGrow: 1,
                background: 'white',
              },
            }}
          >
            <Breadcrumb />
          </Container>
        </Box>
        <Box flexGrow={1} position="relative" maxWidth="100%">
          <Router user={user} />
        </Box>
      </Box>
    </>
  );
};

export default Body;
